import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function WhatYouGet() {
  const items = [{
    title: 'Guía SOS Sueño Infantil',
    desc: 'Un PDF claro y directo que podés leer en una siesta. Te explica paso a paso cómo ayudar a tu bebé a dormir mejor desde esta noche.'
  }, {
    title: 'Plan de las 72 Horas',
    desc: 'Un plan día por día para hacer la transición de brazos a cuna sin llantos ni angustia. Sabés exactamente qué hacer en cada momento.'
  }, {
    title: 'Mapa de Ventanas de Sueño',
    desc: 'Una tabla simple para identificar el momento justo en que tu bebé está listo para dormir, antes de que se pase de cansado.'
  }, {
    title: 'Guía de Ambiente Ideal',
    desc: 'Cómo preparar el cuarto para que todo invite al descanso: luz, sonido, temperatura. Pequeños cambios que hacen una gran diferencia.'
  }, {
    title: 'Guía de Crisis y Regresiones',
    desc: 'Para esas noches difíciles donde sentís que retrocediste. Te muestra cómo mantener el rumbo sin perder lo que ya lograste.'
  }, {
    title: 'Checklist del Cuarto',
    desc: 'Una lista práctica para revisar que el espacio de tu bebé esté preparado. La completás en 10 minutos y listo.'
  }];
  return <section className="bg-cream py-24 px-6 md:px-12" data-id="element-169">
      <div className="max-w-6xl mx-auto" data-id="element-170">
        <FadeIn data-id="element-171">
          <h2 className="text-4xl md:text-5xl text-center mb-16" data-id="element-172">
            Todo lo que incluye tu guía
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-173">
          {items.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-174">
              <div className="bg-white p-8 rounded-3xl shadow-sm border border-brown/5 h-full hover:shadow-md transition-shadow" data-id="element-175">
                <CheckCircle2 className="w-8 h-8 text-periwinkle mb-6" data-id="element-176" />
                <h3 className="text-xl font-bold mb-3" data-id="element-177">{item.title}</h3>
                <p className="text-brown/70" data-id="element-178">{item.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}